@if (events().length) {
  <div class="process-events">
    @if (label()) {
      <span class="process-events__label">{{ label() | translate }}</span>
    }
    <div class="process-events__list">
      @for (event of events(); track event.eventKey) {
        @if (event.eventUrl; as url) {
          <a
            class="process-event"
            [class.process-event--core]="event.kind === 'core'"
            [routerLink]="url"
          >
            <i class="pi pi-bolt" aria-hidden="true"></i>
            <span>
              {{ event.eventLabel | translate }}
              <app-copyable-identifier [value]="event.eventKey"></app-copyable-identifier>
            </span>
          </a>
        } @else {
          <span class="process-event" [class.process-event--core]="event.kind === 'core'">
            <i class="pi pi-bolt" aria-hidden="true"></i>
            <span>
              {{ event.eventLabel | translate }}
              <app-copyable-identifier [value]="event.eventKey"></app-copyable-identifier>
            </span>
          </span>
        }
      }
    </div>
  </div>
}
